"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHoldingViewMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const domain_1 = require("../../../domain");
class UserHoldingViewMapper {
    toDomain(result) {
        const holdingViewArray = lodash_1.default.get(result, "data.getUserHoldingView").map((eachHoldingView) => {
            var _a;
            const { holding, preferredZones } = eachHoldingView, rest = __rest(eachHoldingView, ["holding", "preferredZones"]);
            const visibleZones = (_a = holding === null || holding === void 0 ? void 0 : holding.zones) === null || _a === void 0 ? void 0 : _a.filter((eachZone) => eachZone.status === domain_1.ZoneStatus.VISIBLE);
            const visiblePreferredZones = preferredZones === null || preferredZones === void 0 ? void 0 : preferredZones.filter((eachPreferredZone) => visibleZones === null || visibleZones === void 0 ? void 0 : visibleZones.some((eachZone) => eachZone.name === eachPreferredZone.name));
            return Object.assign(Object.assign({}, rest), { preferredZones: visiblePreferredZones, holding: Object.assign(Object.assign({}, holding), { zones: visibleZones }) });
        });
        return holdingViewArray;
    }
}
exports.UserHoldingViewMapper = UserHoldingViewMapper;
